import { Link } from "@inertiajs/react";
import type { ColumnDef } from "@tanstack/react-table";
import { Eye } from "lucide-react";

import { Button } from "@/components/ui/button";
import type { useOrganizationRoutes } from "@/hooks/use-organization-routes";
import { DataTableColumnHeader } from "@/lib/data-table-column-header";
import type { Sector } from "@/types";

export const columns = (routes: ReturnType<typeof useOrganizationRoutes>): ColumnDef<Sector>[] => [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
    enableSorting: false,
  },
  {
    accessorKey: "code",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Código" />
    ),
    enableSorting: false,
    cell: ({ row }) => {
      const code = row.original.code;
      return code ?? <span className="text-muted-foreground">-</span>;
    },
  },
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Nombre" />
    ),
    enableSorting: false,
  },
  {
    accessorKey: "company.name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Compañía" />
    ),
    enableSorting: false,
    cell: ({ row }) => {
      const company = row.original.company;
      return company?.name ?? <span className="text-muted-foreground">-</span>;
    },
  },
  {
    accessorKey: "work_type",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Tipo de obra" />
    ),
    enableSorting: false,
    cell: ({ row }) => {
      const workType = row.original.work_type;
      return workType ?? <span className="text-muted-foreground">-</span>;
    },
  },
  {
    accessorKey: "project_manager",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Responsable" />
    ),
    enableSorting: false,
    cell: ({ row }) => {
      const manager = row.original.project_manager;
      return manager ?? <span className="text-muted-foreground">-</span>;
    },
  },
  {
    accessorKey: "active",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Estado" />
    ),
    enableSorting: false,
    cell: ({ row }) => {
      const active = row.original.active;
      return active ? (
        <span className="text-green-600 font-medium">Activo</span>
      ) : (
        <span className="text-muted-foreground">Inactivo</span>
      );
    },
  },
  {
    id: "actions",
    header: "Acciones",
    cell: ({ row }) => {
      const sector = row.original;

      return (
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" asChild>
            <Link href={routes.sectors.show(sector)}>
              <Eye className="h-4 w-4" />
              Ver
            </Link>
          </Button>
        </div>
      );
    },
  },
];
